module.exports = __webpack_public_path__ + "img/9.edfcd836.png";